<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "book",
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/m/book.vue